import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import { ConnextData, GetConnextDataQuery } from 'ngx-core-services';

@Injectable({
  providedIn: 'root',
})
export class BlockStateService {
  constructor(private readonly getConnextDataQuery: GetConnextDataQuery) {}

  async getConnextDetails(id: string, query: DocumentNode, refresh = false): Promise<Partial<ConnextData>> {
    const { data: { getConnextData } } = await this.getConnextDataQuery.execute(query, { id: id.toLowerCase() }, refresh);
    return getConnextData;
  }
}
